import * as tslib_1 from "tslib";
import * as React from 'react';
import Badge from 'src/components/Badge';
import { grey700, grey800, green500, grey200, red300 } from 'material-ui/styles/colors';
import { todayString } from 'src/utils/dates';
var styles = {
    container: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'end',
        marginTop: '.5rem'
    },
    badge: {
        marginRight: '.3rem'
    }
};
var TaskCardBadges = function (_a) {
    var task = _a.task;
    var priorityBadge = task.ticketPriority !== '-'
        ? React.createElement(Badge, { color: task.priorityColor, styleOverride: styles.badge }, task.ticketPriority)
        : null;
    var deadlineBadge = !!task.taskDeadline
        ? React.createElement(Badge, { color: green500, styleOverride: styles.badge }, todayString(task.taskDeadline))
        : null;
    var overworkBadge = task.overwork
        ? React.createElement(Badge, { color: grey700, styleOverride: styles.badge }, "T\u00FAl\u00F3ra")
        : null;
    var tagCloudBadge = task.tagCloud
        ? React.createElement(Badge, { color: red300, styleOverride: styles.badge }, task.tagCloud)
        : null;
    var noteStyle = tslib_1.__assign({}, styles.badge, { flex: 1, textAlign: 'left', whiteSpace: 'pre-line', color: grey800 });
    var noteBadge = task.note
        ? React.createElement(Badge, { color: grey200, styleOverride: noteStyle }, task.note)
        : null;
    var containerStyle = task.note
        ? styles.container
        : tslib_1.__assign({}, styles.container, { marginTop: 0 });
    return (React.createElement("div", { style: containerStyle },
        noteBadge,
        priorityBadge,
        deadlineBadge,
        overworkBadge,
        tagCloudBadge));
};
export default TaskCardBadges;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskCardBadges.tsx
// module id = 307
// module chunks = 0